'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNamespace = undefined;

var _reduxActions = require('redux-actions');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createNamespace = exports.createNamespace = function createNamespace(namespaceName) {
  var createActionNs = function createActionNs(type) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return _reduxActions.createAction.apply(undefined, ['' + namespaceName + type].concat(args));
  };
  var createActionsNs = function createActionsNs() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (!args.every(function (arg) {
      return typeof arg === 'string';
    })) {
      throw new Error('createActions: Expect all arguments to be strings. (Action maps are not supported.)');
    }

    return args.reduce(function (result, arg) {
      return Object.assign(result, _defineProperty({}, arg, createActionNs(arg)));
    }, {});
  };

  return {
    createAction: createActionNs,
    createActions: createActionsNs
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions-namespace/lib/index.js
// module id = 665
// module chunks = 0